import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import TimeIsForm from './TimeIsForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(TimeIsForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/TimeIs/TimeIsForm.container.js